import React from 'react';
import { Card } from './ui/card';
import { Shield, Clock, Award, DollarSign, Users, CheckCircle } from 'lucide-react';
import { whyChooseUs } from '../mockData';

const iconMap = {
  0: Clock,
  1: Shield,
  2: Award,
  3: DollarSign,
  4: Users,
  5: CheckCircle
};

const WhyChooseUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose G.S Contractors?
          </h2>
          <p className="text-lg text-gray-600">
            We're not just another contractor – we're your trusted partner in beautiful stonework
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {whyChooseUs.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <Card 
                key={feature.id}
                data-testid={`why-us-pillar-${index}`}
                className="p-6 border-2 border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300 group"
              >
                <div className="flex flex-col items-start space-y-4">
                  <div className="w-12 h-12 bg-emerald-50 rounded-lg flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
                    <Icon className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 bg-emerald-50 rounded-2xl p-8 md:p-12 max-w-5xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div data-testid="why-us-stat-0">
              <div className="text-4xl font-bold text-emerald-600 mb-2">40+</div>
              <div className="text-gray-700 font-medium">Years Experience</div>
            </div>
            <div data-testid="why-us-stat-1">
              <div className="text-4xl font-bold text-emerald-600 mb-2">500+</div>
              <div className="text-gray-700 font-medium">Happy Customers</div>
            </div>
            <div data-testid="why-us-stat-2">
              <div className="text-4xl font-bold text-emerald-600 mb-2">100%</div>
              <div className="text-gray-700 font-medium">Satisfaction Rate</div>
            </div>
            <div data-testid="why-us-stat-3">
              <div className="text-4xl font-bold text-emerald-600 mb-2">24/7</div>
              <div className="text-gray-700 font-medium">Support Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
